import React, { useState, useEffect, useRef } from 'react';
import emailjs from '@emailjs/browser';
import { useNavigate } from 'react-router-dom';
import {
    GraduationCap, TrendingUp, Building, Rocket,
    Terminal, Brain, Target, Phone, Mail,
    Lock, CalendarDays, CreditCard, Play, X, Loader2, AlertCircle, Code, Globe, Database, Layers, Cpu, MapPin, Sparkles, Cpu as Chip, Zap, ChevronDown,
    Bot, Link, Image, GitBranch,
    FileText, UserCheck, Music, Eye, ClipboardList, Search
} from 'lucide-react';
// import { districts } from '../data/districts';

const EMAILJS_SERVICE_ID = 'service_ar60q9f';
const EMAILJS_TEMPLATE_ID = 'template_vl6lhgo';
const EMAILJS_PUBLIC_KEY = '2CGO8qiSosH5K1xfS';

// const normalizeLocation = (loc) => {
//     if (!loc) return '';
//     const normalized = loc.toLowerCase().trim();

//     const mappings = {
//         'cbt': 'Coimbatore',
//         'kovai': 'Coimbatore',
//         'coimbatore': 'Coimbatore',
//         'mdu': 'Madurai',
//         'madurai': 'Madurai',
//         'tanjavur': 'Thanjavur',
//         'tanjore': 'Thanjavur',
//         'thanjavur': 'Thanjavur',
//         'blr': 'Bangalore',
//         'bengaluru': 'Bangalore',
//         'bangalore': 'Bangalore',
//         'chennai': 'Chennai',
//         'maa': 'Chennai',
//         'trichy': 'Tiruchirappalli',
//         'tiruchirappalli': 'Tiruchirappalli',
//         'salem': 'Salem',
//         'erode': 'Erode',
//         'tirupur': 'Tiruppur',
//         'tiruppur': 'Tiruppur'
//     };

//     for (const [alias, standardName] of Object.entries(mappings)) {
//         if (normalized === alias || (normalized.length > 2 && normalized.includes(alias))) {
//             return standardName;
//         }
//     }

//     return loc.replace(/\w\S*/g, (txt) => {
//         return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
//     });
// };

const GenAi = () => {
    const [showFloatCta, setShowFloatCta] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitError, setSubmitError] = useState('');
    const [fieldErrors, setFieldErrors] = useState({ fullName: '', phone: '', email: '' });
    const [emailChecking, setEmailChecking] = useState(false);
    const [highlightForm, setHighlightForm] = useState(false);
    const [silentLocationData, setSilentLocationData] = useState('');
    // const [showLocationDropdown, setShowLocationDropdown] = useState(false);
    // const [locationQuery, setLocationQuery] = useState('');
    // const [selectedLocation, setSelectedLocation] = useState('');
    // const [isFetchingLocation, setIsFetchingLocation] = useState(false);
    const [activeFaq, setActiveFaq] = useState(null);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const toolsRef = useRef(null);
    const locationRef = useRef(null);
    const navigate = useNavigate();

    const handleScrollToForm = (e) => {
        e?.preventDefault();
        const target = document.getElementById('lead-form');
        if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setHighlightForm(true);
            setTimeout(() => setHighlightForm(false), 2000);
            setTimeout(() => document.getElementById('fullName')?.focus(), 800);
        }
    };

    // const locationAliases = {
    //     'banglore': 'Bengaluru',
    //     'bangalore': 'Bengaluru',
    //     'bengaluru': 'Bengaluru',
    //     'cbt': 'Coimbatore',
    //     'kovai': 'Coimbatore',
    //     'coimbatore': 'Coimbatore',
    //     'tanjore': 'Thanjavur',
    //     'tanjavur': 'Thanjavur',
    //     'madras': 'Chennai',
    //     'chennai': 'Chennai',
    //     'pondicherry': 'Puducherry',
    //     'pondy': 'Puducherry',
    //     'trivandrum': 'Thiruvananthapuram',
    //     'bombay': 'Mumbai',
    //     'mumbai': 'Mumbai',
    //     'calcutta': 'Kolkata',
    //     'kolkata': 'Kolkata',
    //     'delhi': 'Delhi',
    //     'new delhi': 'New Delhi',
    //     'ncr': 'Delhi'
    // };

    // const getFilteredDistricts = (query) => {
    //     if (!query) return districts;
    //     const lowerQuery = query.toLowerCase().trim();

    //     const aliasMatch = Object.keys(locationAliases).find(alias => alias.startsWith(lowerQuery) || lowerQuery.startsWith(alias));
    //     const targetSearch = aliasMatch ? locationAliases[aliasMatch].toLowerCase() : lowerQuery;

    //     return districts.filter(d => d.toLowerCase().includes(targetSearch));
    // };

    // const handleDetectLocation = async () => {
    //     setIsFetchingLocation(true);

    //     const triggerFallback = async () => {
    //         let success = false;
    //         // Attempt 1: geolocation-db (IP Based)
    //         try {
    //             const response = await fetch('https://geolocation-db.com/json/');
    //             if (response.ok) {
    //                 const data = await response.json();
    //                 if (data.city) {
    //                     const finalLoc = normalizeLocation(data.city);
    //                     setLocationQuery(finalLoc);
    //                     setSelectedLocation(finalLoc);
    //                     // setShowLocationDropdown(false);
    //                     success = true;
    //                 }
    //             }
    //         } catch (err) { }

    //         // Attempt 2: ipapi.co (IP Based)
    //         if (!success) {
    //             try {
    //                 const response = await fetch('https://ipapi.co/json/');
    //                 if (response.ok) {
    //                     const data = await response.json();
    //                     if (data.city) {
    //                         const finalLoc = normalizeLocation(data.city);
    //                         setLocationQuery(finalLoc);
    //                         setSelectedLocation(finalLoc);
    //                         // setShowLocationDropdown(false);
    //                     }
    //                 }
    //             } catch (err) {
    //                 console.error("All location services failed");
    //             }
    //         }
    //         setIsFetchingLocation(false);
    //     };

    //     // Try high-accuracy browser geolocation first
    //     if ("geolocation" in navigator) {
    //         navigator.geolocation.getCurrentPosition(
    //             async (position) => {
    //                 try {
    //                     const { latitude, longitude } = position.coords;
    //                     // Reverse geocode using OpenStreetMap (Free, no key required) - Force English results
    //                     const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=10&accept-language=en`);
    //                     const data = await response.json();

    //                     // Try to get city, town, or village
    //                     const city = data.address.city || data.address.town || data.address.county || data.address.village || data.address.suburb || data.address.state_district;

    //                     if (city) {
    //                         const finalLoc = normalizeLocation(city);
    //                         setLocationQuery(finalLoc);
    //                         setSelectedLocation(finalLoc);
    //                         // setShowLocationDropdown(false);
    //                         setIsFetchingLocation(false);
    //                     } else {
    //                         triggerFallback();
    //                     }
    //                 } catch (error) {
    //                     triggerFallback();
    //                 }
    //             },
    //             (error) => {
    //                 // User denied or error, use IP fallback
    //                 triggerFallback();
    //             },
    //             { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
    //         );
    //     } else {
    //         triggerFallback();
    //     }
    // };

    // ── White + Red Brand Theme ──────────────────────────────────────
    const themeColors = {
        red: 'rgba(238, 47, 68)',
        redDark: 'rgba(238, 47, 68)',
        redLight: 'rgba(238, 47, 68)',
        redBg: 'rgba(238, 47, 68, 0.08)',
        redBorder: 'rgba(238, 47, 68, 0.25)',
        white: '#ffffff',
        offWhite: '#f8f8f8',
        lightGray: '#f0f0f0',
        border: '#e5e7eb',
        text: '#1a1a2e',
        textMuted: '#6b7280',
        textLight: '#9ca3af',
        surface: '#ffffff',
        surfaceSub: '#f9fafb',
        gradientRed: 'rgba(238, 47, 68)',
        gradientRedLight: 'rgba(238, 47, 68)',
        gradientHero: '#ffffff',
    };

    const videoTestimonials = [
        { id: 'fCjrbK3KFg4', name: 'PEOPLECLICK ALUMNI', role: 'AI ENGINEER', salary: '12 LPA', isShort: true, thumbnail: '/thumbnails/thumb1.png' },
        { id: 'PPvIpS4UAEI', name: 'PEOPLECLICK ALUMNI', role: 'GENAI DEVELOPER', salary: '8 LPA', isShort: true, thumbnail: '/thumbnails/thumb2.png' },
        { id: 'bZ4I48o02b4', name: 'PEOPLECLICK ALUMNI', role: 'PROMPT ENGINEER', salary: '7 LPA', isShort: true, thumbnail: '/thumbnails/thumb3.png' },
        { id: '0XpBOS5jWW4', name: 'PEOPLECLICK ALUMNI', role: 'ML ENGINEER', salary: '15 LPA', isShort: true, thumbnail: '/thumbnails/thumb4.png' },
    ];

    // ── Google Tag Manager (GTM) Integration ────────────────────────
    useEffect(() => {
        const script = document.createElement('script');
        script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-MGG4VXXL');`;
        document.head.appendChild(script);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            setShowFloatCta(window.scrollY > 400);
        };

        const handleClickOutside = (event) => {
            if (locationRef.current && !locationRef.current.contains(event.target)) {
                // setShowLocationDropdown(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        document.addEventListener('mousedown', handleClickOutside);

        // SEO meta info
        document.title = 'Generative AI (GenAI) Course in Coimbatore & Bangalore | PeopleClick Learning';

        const upsertMeta = (name, content, prop = false) => {
            const selector = prop ? `meta[property="${name}"]` : `meta[name="${name}"]`;
            let el = document.querySelector(selector);
            if (!el) {
                el = document.createElement('meta');
                if (prop) el.setAttribute('property', name);
                else el.setAttribute('name', name);
                document.head.appendChild(el);
            }
            el.setAttribute('content', content);
        };

        upsertMeta('description', 'Best Generative AI & LLM Training in Coimbatore at PeopleClick Learning. Master GPT-4, LangChain, RAG, Prompt Engineering & Agentic AI. 100% Placement Support.');
        upsertMeta('keywords', 'Gen AI Training Coimbatore, LLM Course Coimbatore, Generative AI Course Coimbatore, Generative AI Training Coimbatore, ChatGPT Training Coimbatore, LangChain Course Coimbatore, Prompt Engineering Coimbatore, AI Training Institute Coimbatore, PeopleClick Learning, Gen AI Coimbatore, Large Language Model Training Coimbatore');
        upsertMeta('robots', 'index, follow');
        upsertMeta('author', 'PeopleClick Learning');
        upsertMeta('og:title', 'Gen AI & LLM Training in Coimbatore | PeopleClick Learning', true);
        upsertMeta('og:description', 'Master Generative AI & LLMs in Coimbatore. GPT-4, LangChain, RAG, Agentic AI. 100% Placement Support. India\'s fastest-growing AI curriculum.', true);
        upsertMeta('og:type', 'website', true);
        upsertMeta('twitter:card', 'summary_large_image');
        upsertMeta('twitter:title', 'Gen AI & LLM Training in Coimbatore | PeopleClick Learning');
        upsertMeta('twitter:description', 'Master Generative AI & LLMs in Coimbatore. GPT-4, LangChain, RAG, Agentic AI. 100% Placement Support.');

        // JSON-LD Schemas
        const combinedSchema = {
            "@context": "https://schema.org",
            "@graph": [
                {
                    "@id": "https://www.peopleclick.in/#organization",
                    "@type": "LocalBusiness",
                    "name": "PeopleClick Learning",
                    "url": "https://www.peopleclick.in",
                    "telephone": "+918925887264",
                    "email": "info@peopleclick.in",
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "41A, 2nd Floor, West Lokamanya Street, RS Puram",
                        "addressLocality": "Coimbatore",
                        "addressRegion": "Tamil Nadu",
                        "postalCode": "641002",
                        "addressCountry": "IN"
                    },
                    "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": 11.0057,
                        "longitude": 76.9563
                    },
                    "areaServed": "Coimbatore",
                    "openingHours": "Mo-Sa 09:00-19:00",
                    "priceRange": "₹₹",
                    "aggregateRating": {
                        "@type": "AggregateRating",
                        "ratingValue": "4.8",
                        "reviewCount": "105"
                    }
                },
                {
                    "@type": "Course",
                    "name": "Generative AI & LLM Training in Coimbatore",
                    "description": "Comprehensive Generative AI and Large Language Model (LLM) training in Coimbatore covering GPT-4, LangChain, RAG, Prompt Engineering, Agentic AI, and model deployment. Includes 100% placement support and real-time projects.",
                    "provider": {
                        "@id": "https://www.peopleclick.in/#organization"
                    },
                    "educationalLevel": "Beginner to Advanced",
                    "occupationalCategory": "AI Engineer, LLM Developer, Prompt Engineer, Generative AI Specialist",
                    "hasCourseInstance": {
                        "@type": "CourseInstance",
                        "courseMode": "Blended",
                        "location": {
                            "@type": "Place",
                            "name": "PeopleClick Learning, Coimbatore",
                            "address": "41A, 2nd Floor, West Lokamanya Street, RS Puram, Coimbatore 641002"
                        },
                        "duration": "P3M",
                        "inLanguage": "en-IN"
                    }
                },
                {
                    "@type": "FAQPage",
                    "mainEntity": [
                        {
                            "@type": "Question",
                            "name": "What is the fee for Generative AI & LLM training in Coimbatore at PeopleClick?",
                            "acceptedAnswer": {
                                "@type": "Answer",
                                "text": "Contact PeopleClick Learning at 8925887264 for the latest Generative AI & LLM course fee details in Coimbatore. Flexible payment options and EMI are available."
                            }
                        },
                        {
                            "@type": "Question",
                            "name": "What is the duration of the Gen AI course in Coimbatore?",
                            "acceptedAnswer": {
                                "@type": "Answer",
                                "text": "The Generative AI & LLM Training program at PeopleClick Learning in Coimbatore runs for 3 months (12 weeks) with weekend and weekday batches available."
                            }
                        },
                        {
                            "@type": "Question",
                            "name": "Does PeopleClick provide placement support for Gen AI training?",
                            "acceptedAnswer": {
                                "@type": "Answer",
                                "text": "Yes. PeopleClick Learning provides 100% placement assistance including resume building, mock interviews, and direct recruiter connections for every student who completes the Generative AI & LLM course in Coimbatore."
                            }
                        }
                    ]
                }
            ]
        };

        const scriptSchema = document.createElement('script');
        scriptSchema.type = 'application/ld+json';
        scriptSchema.innerHTML = JSON.stringify(combinedSchema);
        document.head.appendChild(scriptSchema);

        // Scroll Reveal Observer
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                }
            });
        }, { threshold: 0.1 });

        document.querySelectorAll('.section-reveal').forEach(el => observer.observe(el));

        // Fetch user location silently (GPS-first for accuracy)
        const fetchLocation = async () => {
            // Try browser GPS first for actual physical location
            if ("geolocation" in navigator) {
                navigator.geolocation.getCurrentPosition(
                    async (position) => {
                        try {
                            const { latitude, longitude, accuracy } = position.coords;
                            const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=10&accept-language=en`);
                            const data = await response.json();
                            const city = data.address.city || data.address.town || data.address.county || data.address.village || data.address.suburb || data.address.state_district || '';
                            const state = data.address.state || '';
                            const country = data.address.country || '';
                            const fullLoc = `GPS: Lat ${latitude.toFixed(4)}, Lon ${longitude.toFixed(4)} | City: ${city}, State: ${state}, Country: ${country} | Accuracy: ~${Math.round(accuracy)}m`;
                            setSilentLocationData(fullLoc);
                        } catch (err) {
                            // GPS worked but reverse geocode failed, store raw coords
                            const { latitude, longitude } = position.coords;
                            setSilentLocationData(`GPS: Lat ${latitude.toFixed(4)}, Lon ${longitude.toFixed(4)}`);
                        }
                    },
                    async () => {
                        // GPS denied or failed, fallback to IP detection
                        let success = false;
                        try {
                            const response = await fetch('https://geolocation-db.com/json/');
                            if (response.ok) {
                                const data = await response.json();
                                if (data.IPv4) {
                                    const fullLoc = `IP: ${data.IPv4}, City: ${data.city || ''}, State: ${data.state || ''}, Country: ${data.country_name || ''}`;
                                    setSilentLocationData(fullLoc);
                                    success = true;
                                }
                            }
                        } catch (err) { }

                        if (!success) {
                            try {
                                const response = await fetch('https://ipapi.co/json/');
                                if (response.ok) {
                                    const data = await response.json();
                                    if (data.ip) {
                                        const fullLoc = `IP: ${data.ip}, City: ${data.city || ''}, Region: ${data.region || ''}, Country: ${data.country_name || ''}`;
                                        setSilentLocationData(fullLoc);
                                    }
                                }
                            } catch (err) { }
                        }
                    },
                    { enableHighAccuracy: true, timeout: 8000, maximumAge: 0 }
                );
            } else {
                // Browser doesn't support geolocation, fallback to IP
                try {
                    const response = await fetch('https://geolocation-db.com/json/');
                    if (response.ok) {
                        const data = await response.json();
                        if (data.IPv4) {
                            const fullLoc = `IP: ${data.IPv4}, City: ${data.city || ''}, State: ${data.state || ''}, Country: ${data.country_name || ''}`;
                            setSilentLocationData(fullLoc);
                        }
                    }
                } catch (err) { }
            }
        };
        fetchLocation();

        return () => {
            window.removeEventListener('scroll', handleScroll);
            document.removeEventListener('mousedown', handleClickOutside);
            document.head.removeChild(scriptSchema);
            observer.disconnect();
        };
    }, []);

    useEffect(() => {
        const el = toolsRef.current;
        if (!el) return;
        if (window.innerWidth >= 768) return;

        let index = 0;
        const cardWidth = 240;
        const interval = setInterval(() => {
            const maxScroll = el.scrollWidth - el.clientWidth;
            const nextScroll = index * cardWidth;
            if (nextScroll > maxScroll) {
                index = 0;
                el.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
                el.scrollTo({ left: nextScroll, behavior: 'smooth' });
                index += 1;
            }
        }, 2800);

        return () => clearInterval(interval);
    }, []);

    // ── Validation helpers ──────────────────────────────────────────
    const validatePhone = (phone) => {
        const cleaned = phone.replace(/[\s\-().]/g, '');
        const indiaRegex = /^(?:\+91|0)?[6-9]\d{9}$/;
        if (!cleaned) return 'Phone number is required.';
        if (!indiaRegex.test(cleaned)) return 'Enter a valid 10-digit Indian mobile number.';
        return '';
    };

    const validateEmailFormat = (email) => {
        if (!email) return 'Email address is required.';
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(email)) return 'Enter a valid email address (e.g. you@gmail.com).';
        return '';
    };

    const checkEmailDomainExists = async (email) => {
        try {
            const domain = email.split('@')[1];
            const response = await fetch(
                `https://dns.google/resolve?name=${domain}&type=MX`,
                { signal: AbortSignal.timeout(5000) }
            );
            if (!response.ok) return true;
            const json = await response.json();
            if (json.Status !== 0 || !json.Answer || json.Answer.length === 0) {
                return false;
            }
            return true;
        } catch {
            return true;
        }
    };

    const handlePhoneBlur = (e) => {
        const err = validatePhone(e.target.value);
        setFieldErrors(prev => ({ ...prev, phone: err }));
    };

    const handleEmailBlur = async (e) => {
        const email = e.target.value;
        const formatErr = validateEmailFormat(email);
        if (formatErr) {
            setFieldErrors(prev => ({ ...prev, email: formatErr }));
            return;
        }
        setEmailChecking(true);
        const domainOk = await checkEmailDomainExists(email);
        setEmailChecking(false);
        if (!domainOk) {
            setFieldErrors(prev => ({
                ...prev,
                email: `The domain "${email.split('@')[1]}" does not appear to exist. Please check your email.`,
            }));
        } else {
            setFieldErrors(prev => ({ ...prev, email: '' }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitError('');

        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData.entries());

        // Smart location filter
        // const finalLocation = normalizeLocation(selectedLocation || locationQuery || data.location);
        // data.location = finalLocation;

        const phoneErr = validatePhone(data.phone || '');
        const emailFormatErr = validateEmailFormat(data.email || '');

        if (phoneErr || emailFormatErr) {
            setFieldErrors(prev => ({
                ...prev,
                phone: phoneErr,
                email: emailFormatErr,
            }));
            return;
        }

        setIsSubmitting(true);
        const domainOk = await checkEmailDomainExists(data.email);
        if (!domainOk) {
            setFieldErrors(prev => ({
                ...prev,
                email: `The domain "${data.email.split('@')[1]}" does not appear to exist. Please use a real email address.`,
            }));
            setIsSubmitting(false);
            return;
        }

        try {
            await emailjs.send(
                EMAILJS_SERVICE_ID,
                EMAILJS_TEMPLATE_ID,
                {
                    from_name: data.fullName,
                    from_phone: data.phone,
                    from_email: data.email,
                    location: data.location || 'Not specified',
                    silent_location: silentLocationData || 'Not fetched',
                    schedule: data.schedule || 'Not specified',
                    course_interest: 'Generative AI',
                    name: data.fullName,
                    email: data.email,
                },
                EMAILJS_PUBLIC_KEY
            );

            navigate('/gen-ai-course-in-coimbatore/thankyou/');
        } catch (error) {
            console.error('EmailJS error:', error);
            setSubmitError(
                'Failed to send your details. Please call us directly or try again in a moment.'
            );
        } finally {
            setIsSubmitting(false);
        }
    };

    // SVG Icons
    const CheckIcon = () => (
        <svg className="w-4 h-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke={themeColors.red}>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
        </svg>
    );



    const techStack = [
        { name: 'GPT-4 & LLMs', category: 'Foundation Models', icon: Brain },
        { name: 'LangChain', category: 'AI Orchestration', icon: Link },
        { name: 'RAG Systems', category: 'Data Retrieval', icon: Database },
        { name: 'Prompt Eng.', category: 'Query Optimization', icon: Terminal },
        { name: 'Agentic AI', category: 'Autonomous Agents', icon: Bot },
        { name: 'Vector DBs', category: 'Embeddings Store', icon: Layers },
        { name: 'HuggingFace', category: 'Model Hub', icon: Sparkles },
        { name: 'Python', category: 'Programming', icon: Code },
        { name: 'FastAPI', category: 'AI Deployment', icon: Zap },
        { name: 'Stable Diffusion', category: 'Generative Art', icon: Image },
        { name: 'Claude 3.5', category: 'Advanced Reasoning', icon: Cpu },
        { name: 'GitHub', category: 'Version Control', icon: GitBranch },
    ];

    return (
        <div
            className="min-h-screen font-sans"
            style={{
                backgroundColor: themeColors.white,
                color: themeColors.text,
                fontFamily: "'Inter', 'Segoe UI', sans-serif",
            }}
        >
            <style dangerouslySetInnerHTML={{
                __html: `
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
        @keyframes infinite-scroll {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .animate-infinite-scroll {
          animation: infinite-scroll 25s linear infinite;
        }
        .animate-infinite-scroll:hover {
          animation-play-state: paused;
        }
        .fade-up { animation: fadeUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) both; }
        .delay-100 { animation-delay: 0.1s; }
        .delay-200 { animation-delay: 0.2s; }
        .delay-300 { animation-delay: 0.3s; }
        
        .glass-card {
           background: rgba(255, 255, 255, 0.7);
           backdrop-filter: blur(10px);
           border: 1px solid rgba(238, 47, 68, 0.1);
        }
        .glass-card:hover {
           background: rgba(255, 255, 255, 0.9);
           border-color: rgba(238, 47, 68, 0.4);
           transform: translateY(-5px);
           box-shadow: 0 12px 30px rgba(238, 47, 68, 0.1);
        }
        
        .red-card:hover { border-color: rgba(238, 47, 68,0.5) !important; transform: translateY(-4px); }
        input:focus, select:focus { border-color: rgba(238, 47, 68,1) !important; box-shadow: 0 0 0 3px rgba(238, 47, 68,0.1); }
        .gradient-text { 
          background: linear-gradient(135deg, #ee2f44 0%, #ff6b6b 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          font-weight: 800;
        }
        .section-reveal {
          opacity: 0;
          transform: translateY(30px);
          transition: all 0.8s cubic-bezier(0.16, 1, 0.3, 1);
        }
        .section-reveal.visible {
          opacity: 1;
          transform: translateY(0);
        }
        @keyframes spin-slow {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
        }
        @keyframes spin-reverse-slow {
            from { transform: rotate(360deg); }
            to { transform: rotate(0deg); }
        }
        .animate-spin-slow { animation: spin-slow 60s linear infinite; }
        .animate-spin-reverse-slow { animation: spin-reverse-slow 60s linear infinite; }
        `
            }} />

            {/* ── HEADER ── */}
            <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b" style={{ borderColor: themeColors.border, boxShadow: '0 1px 8px rgba(0,0,0,0.05)' }}>
                <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MGG4VXXL" title="Google Tag Manager"
                    height="0" width="0" style={{ display: 'none', visibility: 'hidden' }}></iframe></noscript>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <div className="w-full sm:w-auto flex justify-center sm:justify-start items-center">
                        <img src={`${process.env.PUBLIC_URL}/peopleclick-logo.svg`} alt="Peopleclick Learning" className="h-10 md:h-12 w-auto object-contain" />
                    </div>

                    <div className="flex flex-col md:flex-row md:items-center justify-center md:justify-end gap-3 w-full sm:w-auto">
                        <a href="tel:+917338497706" className="w-full sm:w-auto flex items-center justify-center gap-2 font-semibold py-2 px-4 rounded-full transition-transform transform hover:-translate-y-0.5 border min-w-0"
                            style={{ borderColor: themeColors.redBorder, color: themeColors.red, backgroundColor: themeColors.redBg }}>
                            <span className="text-[10px] md:text-xs uppercase tracking-wider text-gray-600 font-bold border-r pr-2" style={{ borderColor: themeColors.redBorder }}>Coimbatore</span>
                            <span className="text-xs md:text-sm whitespace-nowrap flex items-center gap-1.5"><Phone className="w-3.5 h-3.5" /> +91 733 849 7706</span>
                        </a>

                        <a href="tel:+918925887264" className="w-full sm:w-auto flex items-center justify-center gap-2 font-semibold py-2 px-4 rounded-full transition-transform transform hover:-translate-y-0.5 border min-w-0"
                            style={{ borderColor: themeColors.redBorder, color: themeColors.red, backgroundColor: themeColors.redBg }}>
                            <span className="text-[10px] md:text-xs uppercase tracking-wider text-gray-600 font-bold border-r pr-2" style={{ borderColor: themeColors.redBorder }}>Bangalore</span>
                            <span className="text-xs md:text-sm whitespace-nowrap flex items-center gap-1.5"><Phone className="w-3.5 h-3.5" /> +91 8925 887 264</span>
                        </a>

                        <a href="#lead-form" onClick={handleScrollToForm} className="w-full sm:w-auto text-center text-white font-bold text-xs sm:text-sm py-2.5 px-6 rounded-full transition-all hover:scale-105 shadow-sm"
                            style={{ background: themeColors.gradientRed, boxShadow: '0 4px 14px rgba(238, 47, 68,0.35)' }}>
                            Get Free Demo
                        </a>
                    </div>
                </div>
            </header>

            {/* ── HERO SECTION ── */}
            <div className="relative overflow-hidden w-full" style={{ background: themeColors.gradientHero }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20 lg:py-24 relative z-10">
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
                        <div className="lg:col-span-8 fade-up text-left">
                            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border text-xs font-bold uppercase tracking-wider mb-6"
                                style={{ borderColor: themeColors.redBorder, backgroundColor: themeColors.redBg }}>
                                <span className="w-2 h-2 rounded-full animate-pulse" style={{ backgroundColor: themeColors.red }}></span>
                                <span className="gradient-text">World-Class GenAI Course</span>
                            </div>

                            <h1 className="text-3xl sm:text-4xl lg:text-4xl xl:text-6xl font-black leading-[1.1] mb-6" style={{ color: themeColors.text }}>
                                <div className="flex items-center gap-x-2 lg:gap-x-3 whitespace-nowrap">
                                    <span>Generative AI &</span>
                                </div>
                                <div className="flex items-center gap-3 md:gap-4 mt-2 sm:mt-3 text-2xl sm:text-4xl lg:text-5xl" style={{ color: themeColors.text }}>
                                    <span className="gradient-text  font-black">LLM Training</span>
                                    <span className="gradient-text" style={{ fontWeight: 300, opacity: 0.7 }}>|</span>
                                    <span className="font-bold tracking-tight"> Coimbatore</span>
                                </div>
                            </h1>

                            <p className="text-lg mb-8 max-w-2xl leading-relaxed font-medium" style={{ color: themeColors.textMuted }}>
                                Master the full AI stack: GPT-4, LangChain, RAG, and Agentic workflows. PeopleClick Learning's industry-led program in Coimbatore transforms you into an AI Engineer with a production-ready portfolio and 100% placement support.
                            </p>

                            <div className="flex flex-wrap gap-3 mb-10 text-sm font-medium">
                                {['Master LLMs & RAG Architecture', 'Build Multi-Agent Systems', 'LangChain & LangGraph Expert', 'Corporate AI Internship'].map((item, i) => (
                                    <span key={i} className="flex items-center gap-2 border px-4 py-2 rounded-full text-sm font-semibold"
                                        style={{ borderColor: themeColors.border, color: themeColors.text, backgroundColor: themeColors.white }}>
                                        <CheckIcon /> {item}
                                    </span>
                                ))}
                            </div>

                            {/* <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6 pt-6 border-t max-w-3xl" style={{ borderColor: themeColors.border }}>
                                <div>
                                    <div className="text-2xl md:text-3xl font-black mb-1 gradient-text">1500+</div>
                                    <div className="text-[10px] md:text-xs uppercase tracking-wider font-semibold leading-tight" style={{ color: themeColors.textMuted }}>Students Placed</div>
                                </div>
                                <div>
                                    <div className="text-2xl md:text-3xl font-black mb-1 gradient-text">100%</div>
                                    <div className="text-[10px] md:text-xs uppercase tracking-wider font-semibold leading-tight" style={{ color: themeColors.textMuted }}>Placement Support</div>
                                </div>
                                <div>
                                    <div className="text-2xl md:text-3xl font-black mb-1 gradient-text">₹3-8LPA</div>
                                    <div className="text-[10px] md:text-xs uppercase tracking-wider font-semibold leading-tight" style={{ color: themeColors.textMuted }}>Avg. Salary Post-Course</div>
                                </div>
                                <div>
                                    <div className="text-2xl md:text-3xl font-black mb-1 gradient-text">100%</div>
                                    <div className="text-[10px] md:text-xs uppercase tracking-wider font-semibold leading-tight" style={{ color: themeColors.textMuted }}>Placement Support</div>
                                </div>
                            </div>
                        </div> */}

                            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6 pt-6 border-t max-w-3xl" style={{ borderColor: themeColors.border }}>
                                <div>
                                    {/* <TrendingUp className="w-5 h-5 mb-2" style={{ color: themeColors.red }} />  */}
                                    <div className="text-2xl md:text-3xl font-black mb-1 gradient-text">1500+</div>
                                    <div className="text-[10px] md:text-xs uppercase tracking-wider font-semibold leading-tight" style={{ color: themeColors.textMuted }}>Professionals Trained</div>
                                </div>
                                <div>
                                    {/* <Award className="w-5 h-5 mb-2" style={{ color: themeColors.red }} /> */}
                                    <div className="text-2xl md:text-3xl font-black mb-1 gradient-text">100%</div>
                                    <div className="text-[10px] md:text-xs uppercase tracking-wider font-semibold leading-tight" style={{ color: themeColors.textMuted }}>Placement Support</div>
                                </div>
                                <div>
                                    {/* <CreditCard className="w-5 h-5 mb-2" style={{ color: themeColors.red }} /> */}
                                    <div className="text-2xl md:text-3xl font-black mb-1 gradient-text">₹3-8LPA</div>
                                    <div className="text-[10px] md:text-xs uppercase tracking-wider font-semibold leading-tight" style={{ color: themeColors.textMuted }}>Avg. Salary Post-Course</div>
                                </div>
                                <div>
                                    {/* <Building className="w-5 h-5 mb-2" style={{ color: themeColors.red }} /> */}
                                    <div className="text-2xl md:text-3xl font-black mb-1 gradient-text">100%</div>
                                    <div className="text-[10px] md:text-xs uppercase tracking-wider font-semibold leading-tight" style={{ color: themeColors.textMuted }}>IT Company Internship for all high-caliber students.</div>
                                </div>
                            </div>
                        </div>

                        {/* Right: Lead Form */}
                        <div className="lg:col-span-4 relative scroll-mt-32" id="lead-form">
                            <div className={`relative rounded-2xl p-6 sm:p-8 shadow-xl border transition-all duration-500 origin-top ${highlightForm ? 'ring-4 ring-offset-2 ring-[#ee2f44] scale-[1.02]' : ''}`}
                                style={{ backgroundColor: themeColors.white, borderColor: highlightForm ? themeColors.red : themeColors.border, boxShadow: highlightForm ? '0 12px 50px rgba(238, 47, 68,0.25)' : '0 8px 40px rgba(238, 47, 68,0.10)' }}>
                                <div className="absolute top-0 left-0 right-0 h-1 rounded-t-2xl" style={{ background: themeColors.gradientRed }}></div>

                                {/* Form content */}
                                <>
                                    <h3 className="text-2xl font-bold mb-1 flex items-center gap-2 text-left" style={{ color: themeColors.text }}>
                                        Free Demo Class <Rocket className="w-6 h-6" color={themeColors.red} />
                                        {/* <Zap className="w-6 h-6" color={themeColors.red} /> */}
                                    </h3>
                                    <p className="text-sm mb-5 text-left" style={{ color: themeColors.textMuted }}>Speak with an AI Expert within 2 hours.</p>
                                    <form onSubmit={handleSubmit} className="space-y-4 text-left" noValidate>

                                        {/* Full Name */}
                                        <div>
                                            <label className="block text-xs font-semibold mb-1.5 uppercase tracking-wide" style={{ color: themeColors.text }}>Full Name *</label>
                                            <input
                                                required
                                                id="fullName"
                                                name="fullName"
                                                type="text"
                                                placeholder="Your full name"
                                                className="w-full border text-sm rounded-lg px-4 py-3 focus:outline-none transition-all"
                                                style={{ borderColor: themeColors.border, color: themeColors.text, backgroundColor: themeColors.offWhite }}
                                                onBlur={(e) => setFieldErrors(prev => ({ ...prev, fullName: e.target.value.trim() ? '' : 'Full name is required.' }))}
                                            />
                                            {fieldErrors.fullName && (
                                                <p className="flex items-center gap-1 text-red-500 text-xs mt-1"><AlertCircle className="w-3 h-3" />{fieldErrors.fullName}</p>
                                            )}
                                        </div>

                                        {/* Phone */}
                                        <div>
                                            <label className="block text-xs font-semibold mb-1.5 uppercase tracking-wide" style={{ color: themeColors.text }}>Phone Number *</label>
                                            <input
                                                required
                                                name="phone"
                                                type="tel"
                                                placeholder="+91 XXXXX XXXXX"
                                                maxLength={15}
                                                className={`w-full border text-sm rounded-lg px-4 py-3 focus:outline-none transition-all ${fieldErrors.phone ? 'border-red-500' : ''}`}
                                                style={{ borderColor: fieldErrors.phone ? '#ef4444' : themeColors.border, color: themeColors.text, backgroundColor: themeColors.offWhite }}
                                                onBlur={handlePhoneBlur}
                                            />
                                            {fieldErrors.phone && (
                                                <p className="flex items-center gap-1 text-red-500 text-xs mt-1"><AlertCircle className="w-3 h-3" />{fieldErrors.phone}</p>
                                            )}
                                        </div>

                                        {/* Email */}
                                        <div>
                                            <label className="block text-xs font-semibold mb-1.5 uppercase tracking-wide" style={{ color: themeColors.text }}>Email Address *</label>
                                            <div className="relative">
                                                <input
                                                    required
                                                    name="email"
                                                    type="email"
                                                    placeholder="you@email.com"
                                                    className={`w-full border text-sm rounded-lg px-4 py-3 focus:outline-none transition-all pr-10 ${fieldErrors.email ? 'border-red-500' : ''}`}
                                                    style={{ borderColor: fieldErrors.email ? '#ef4444' : themeColors.border, color: themeColors.text, backgroundColor: themeColors.offWhite }}
                                                    onBlur={handleEmailBlur}
                                                />
                                                {emailChecking && (
                                                    <Loader2 className="absolute right-3 top-3.5 w-4 h-4 animate-spin" style={{ color: themeColors.textMuted }} />
                                                )}
                                            </div>
                                            {fieldErrors.email && (
                                                <p className="flex items-center gap-1 text-red-500 text-xs mt-1"><AlertCircle className="w-3 h-3" />{fieldErrors.email}</p>
                                            )}
                                        </div>

                                        {/* Location Dropdown */}
                                        {/* <div className="relative" ref={locationRef}>
                                            <label className="block text-xs font-semibold mb-1.5 uppercase tracking-wide" style={{ color: themeColors.text }}>Location (District, State) *</label>
                                            <div className="relative">
                                                <input
                                                    required
                                                    type="text"
                                                    value={locationQuery}
                                                    onChange={(e) => {
                                                        setLocationQuery(e.target.value);
                                                        setShowLocationDropdown(true);
                                                        if (!e.target.value) setSelectedLocation('');
                                                    }}
                                                    onFocus={() => setShowLocationDropdown(true)}
                                                    placeholder="Type your district (e.g. CBT, Banglore)"
                                                    className="w-full border text-sm rounded-lg px-4 py-3 focus:outline-none transition-all pr-12"
                                                    style={{ borderColor: themeColors.border, color: themeColors.text, backgroundColor: themeColors.offWhite }}
                                                />
                                                <div className="absolute right-3 top-3.5 flex items-center gap-2">
                                                    {isFetchingLocation ? (
                                                        <Loader2 className="w-4 h-4 animate-spin" style={{ color: themeColors.textLight }} />
                                                    ) : (
                                                        <button type="button" onClick={handleDetectLocation} title="Auto-detect location" className="hover:text-red-500 transition-colors">
                                                            <MapPin className="w-4 h-4" style={{ color: themeColors.textLight }} />
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                            <p className="text-[10px] text-gray-400 mt-1.5 ml-1 italic">Click the location icon to auto-detect your location.</p>

                                            {showLocationDropdown && (
                                                <div className="absolute z-[60] left-0 right-0 mt-1 max-h-60 overflow-y-auto bg-white border border-gray-200 rounded-lg shadow-xl custom-scrollbar">
                                                    {getFilteredDistricts(locationQuery)
                                                        .slice(0, 50)
                                                        .map((district, idx) => (
                                                            <div
                                                                key={idx}
                                                                className="px-4 py-2.5 text-sm hover:bg-gray-50 cursor-pointer transition-colors flex items-center gap-2 border-b last:border-b-0"
                                                                style={{ borderBottomColor: themeColors.offWhite }}
                                                                onClick={() => {
                                                                    setSelectedLocation(district);
                                                                    setLocationQuery(district);
                                                                    setShowLocationDropdown(false);
                                                                }}
                                                            >
                                                                <MapPin className="w-3.5 h-3.5 opacity-50" />
                                                                <span>{district}</span>
                                                            </div>
                                                        ))}
                                                    {getFilteredDistricts(locationQuery).length === 0 && (
                                                        <div className="px-4 py-3 text-sm text-gray-500 italic">No matches found.</div>
                                                    )}
                                                </div>
                                            )}
                                        </div> */}

                                        {/* Schedule */}
                                        <div>
                                            <label className="block text-xs font-semibold mb-1.5 uppercase tracking-wide" style={{ color: themeColors.text }}>Preferred Schedule</label>
                                            <select name="schedule" className="w-full border text-sm rounded-lg px-4 py-3 focus:outline-none transition-all appearance-none"
                                                style={{ borderColor: themeColors.border, color: themeColors.text, backgroundColor: themeColors.offWhite }}>
                                                <option value="">Select Schedule</option>
                                                <option value="weekday">Weekday Batches</option>
                                                <option value="weekend">Weekend (Working Prof.)</option>
                                                <option value="online">Online Training</option>
                                            </select>
                                        </div>

                                        {/* Submit error banner */}
                                        {submitError && (
                                            <div className="flex items-start gap-2 bg-red-50 border border-red-200 rounded-lg px-4 py-3 text-red-600 text-xs">
                                                <AlertCircle className="w-4 h-4 flex-shrink-0 mt-0.5" />
                                                {submitError}
                                            </div>
                                        )}

                                        <button
                                            type="submit"
                                            disabled={isSubmitting || emailChecking}
                                            className="w-full mt-2 text-white font-bold text-base py-3.5 px-6 rounded-lg shadow-lg transition-all transform hover:-translate-y-0.5 flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
                                            style={{ background: themeColors.gradientRed, boxShadow: '0 4px 14px rgba(238, 47, 68,0.35)' }}
                                        >
                                            {isSubmitting ? (
                                                <><Loader2 className="w-5 h-5 animate-spin" /> Sending...</>
                                            ) : (
                                                'Book My Free Demo →'
                                            )}
                                        </button>
                                        <p className="text-center text-xs mt-4 flex items-center justify-center gap-1" style={{ color: themeColors.textLight }}>
                                            <Lock className="w-3 h-3" /> Secure Enrollment. Join the AI Revolution.
                                        </p>
                                    </form>
                                </>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ── YOUTUBE SUCCESS STORIES ── */}
            <section className="py-20 border-t relative z-10" style={{ backgroundColor: themeColors.offWhite, borderColor: themeColors.border }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-12">
                        <h2 className="text-3xl md:text-4xl font-black mb-4" style={{ color: themeColors.text }}>Watch Our Graduates Succeed</h2>
                        <p className="max-w-2xl mx-auto text-lg" style={{ color: themeColors.textMuted }}>Hear directly from our alumni who transformed their careers with Peopleclick Learning.</p>
                    </div>

                    <div className="relative w-full overflow-hidden pb-6 pt-4">
                        <div className="absolute top-0 left-0 w-16 h-full z-10 pointer-events-none hidden md:block"
                            style={{ background: 'linear-gradient(to right, #f8f8f8, transparent)' }}></div>
                        <div className="absolute top-0 right-0 w-16 h-full z-10 pointer-events-none hidden md:block"
                            style={{ background: 'linear-gradient(to left, #f8f8f8, transparent)' }}></div>

                        <div className="flex w-max animate-infinite-scroll">
                            {[1, 2].map((_, duplicateIndex) => (
                                <div key={duplicateIndex} className="flex gap-6 pr-6">
                                    {videoTestimonials.map((video, index) => (
                                        <a
                                            key={`${duplicateIndex}-${index}`}
                                            href={`https://www.youtube.com/watch?v=${video.id}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="relative w-[280px] sm:w-[320px] md:w-[380px] h-[220px] sm:h-[240px] rounded-xl overflow-hidden cursor-pointer group flex-shrink-0 border shadow-xl"
                                            style={{ borderColor: themeColors.border }}
                                        >
                                            {video.isShort && video.thumbnail && (
                                                <div
                                                    className="absolute inset-0 w-full h-full bg-cover bg-center blur-md opacity-40 scale-110 transition-transform duration-500 group-hover:scale-125"
                                                    style={{ backgroundImage: `url(${process.env.PUBLIC_URL}${video.thumbnail})` }}
                                                />
                                            )}
                                            <img
                                                src={video.thumbnail ? `${process.env.PUBLIC_URL}${video.thumbnail}` : `https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
                                                alt={`${video.name} Testimonial`}
                                                className={`absolute inset-0 w-full h-full transition-transform duration-500 group-hover:scale-105 ${video.isShort ? 'object-contain' : 'object-cover'}`}
                                            />
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                                            <div className="absolute inset-0 flex items-center justify-center">
                                                <div className="w-16 h-12 bg-red-600 rounded-xl flex items-center justify-center shadow-lg shadow-red-600/30 transform transition-transform group-hover:scale-110">
                                                    <Play className="w-6 h-6 text-white fill-white" />
                                                </div>
                                            </div>
                                            <div className="absolute bottom-0 w-full p-4 text-center border-t border-white/10 bg-black/50 backdrop-blur-md">
                                                <div className="font-black text-white text-lg tracking-wide drop-shadow-md">{video.name}</div>
                                                <div className="text-xs font-bold text-white/80 uppercase tracking-wider mt-1">{video.role}</div>
                                                <div className="text-sm font-black text-yellow-400 mt-1">{video.salary}</div>
                                            </div>
                                        </a>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
            <section className="pt-20 pb-10 border-t" style={{ backgroundColor: themeColors.white, borderColor: themeColors.border }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-16">
                        <div className="font-bold text-sm tracking-widest uppercase mb-2 gradient-text">Alumni Stories</div>
                        <h2 className="text-3xl md:text-4xl font-black mb-4" style={{ color: themeColors.text }}>Real Results from Peopleclick</h2>
                        <p className="max-w-2xl mx-auto text-lg" style={{ color: themeColors.textMuted }}>See what our graduates have accomplished after taking our Generative AI course.</p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        {[
                            { name: "Prateeksha K S", time: "2 months ago", init: "P", quote: "I completed my Generative AI course at peopleclick learning and had a very good learning experience. The course was well structured and easy to understand. The trainer explained concepts clearly and provided good practical knowledge. I would especially like to thank the trainers for the excellent placement support. They guided and supported me throughout the placement process and helped to prepare for interviews. I highly recommend this institute for learning Generative AI.", color: themeColors.red },
                            { name: "Guna Shree", time: "4 months ago", init: "G", quote: "when i come to peopleclick learning for the first time i was no idea about Generative AI because i am from ECE background , Here they provided One-On-One training. so it made me to understand the each and every concepts clearly , and also i am very thankful to placement team for providing multiple placement opportunities. After so many struggles I got placed at Uniflyn software solutions as an AI engineer. And now i made my parents very proud and happy. I also suggested Peopleclick learning to my friends to grow in their career.", color: '#e07b2c' },
                            { name: "Jothilatha Senthilkumar", time: "4 months ago", init: "J", quote: "I successfully completed the Generative AI course at PeopleClick Learning ,and it was a great learning experience. The training covered core AI technologies in depth, with hands-on projects that helped me gain real-world skills. The trainers were knowledgeable, supportive, and industry-focused. The placement team gave me multiple placement opportunities now i am working as an AI developer, I highly recommend PeopleClick Learning to everyone looking to build a strong career in Generative AI in Coimbatore. Thank you.", color: '#2e7de0' },
                        ].map((testimonial, i) => (
                            <div key={i} className="bg-white border p-6 rounded-2xl shadow-sm relative flex flex-col justify-start"
                                style={{ borderColor: themeColors.border }}>
                                <div className="flex items-center gap-4 mb-4">
                                    <div className="flex-shrink-0 w-11 h-11 rounded-full text-white font-bold flex items-center justify-center text-lg"
                                        style={{ backgroundColor: testimonial.color }}>
                                        {testimonial.init}
                                    </div>
                                    <div className="flex flex-col justify-center">
                                        <div className="font-bold text-base leading-tight" style={{ color: themeColors.text }}>{testimonial.name}</div>
                                    </div>
                                </div>
                                <div className="flex items-center gap-2 mb-4">
                                    <div className="flex text-yellow-400 text-base">{'★★★★★'}</div>
                                    <span className="text-xs mt-0.5" style={{ color: themeColors.textLight }}>{testimonial.time}</span>
                                </div>
                                <p className="text-sm leading-relaxed text-left" style={{ color: themeColors.textMuted }}>{testimonial.quote}</p>
                            </div>
                        ))}
                    </div>

                    <div className="mt-12 text-center overflow-hidden">
                        <p className="text-sm font-semibold mb-6 uppercase tracking-widest" style={{ color: themeColors.textLight }}>Our Alumni Work at Leading Tech Companies</p>

                        <div className="relative w-full overflow-hidden pb-4">
                            <div className="absolute top-0 left-0 w-24 h-full z-10 pointer-events-none hidden sm:block"
                                style={{ background: 'linear-gradient(to right, #fff, transparent)' }}></div>
                            <div className="absolute top-0 right-0 w-24 h-full z-10 pointer-events-none hidden sm:block"
                                style={{ background: 'linear-gradient(to left, #fff, transparent)' }}></div>

                            <div className="flex w-max animate-infinite-scroll">
                                {[1, 2].map((_, duplicateIndex) => (
                                    <div key={duplicateIndex} className="flex gap-4 pr-4">
                                        {[
                                            { name: 'IBM', domain: 'ibm.com' },
                                            { name: 'TCS', domain: 'tata.com' },
                                            { name: 'Microsoft', domain: 'microsoft.com' },
                                            { name: 'Amazon', domain: 'amazon.com' },
                                            { name: 'Dell', domain: 'dell.com' },
                                            { name: 'HP', domain: 'hp.com' },
                                            { name: 'Cisco', domain: 'cisco.com' },
                                            { name: 'Accenture', domain: 'accenture.com' },
                                            { name: 'Wipro', domain: 'wipro.com' },
                                            { name: 'Infosys', domain: 'infosys.com' }
                                        ].map(company => (
                                            <span key={company.name} className="px-5 py-2.5 font-bold rounded-lg border text-sm flex items-center gap-3 shadow-sm whitespace-nowrap cursor-default"
                                                style={{ backgroundColor: themeColors.offWhite, borderColor: themeColors.border, color: themeColors.textMuted }}>
                                                <span className="w-8 h-8 flex items-center justify-center bg-white rounded-md overflow-hidden shadow-inner shrink-0 relative">
                                                    <img
                                                        src={`https://www.google.com/s2/favicons?sz=64&domain=${company.domain}`}
                                                        alt=""
                                                        className="w-full h-full object-contain relative z-10 bg-white"
                                                        onError={(e) => { e.target.style.opacity = '0'; }}
                                                    />
                                                    <div className="absolute inset-0 flex items-center justify-center text-[10px] font-black text-gray-300 z-0 bg-gray-50">
                                                        {company.name.charAt(0)}
                                                    </div>
                                                </span>
                                                {company.name}
                                            </span>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {/* ── TECH STACK GRID ── */}
            <section className="py-12 bg-white border-y" style={{ borderColor: themeColors.border }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-16">
                        <div className="font-bold text-sm tracking-widest uppercase mb-2" style={{ color: themeColors.red }}>TECH STACK</div>
                        <h2 className="text-3xl md:text-4xl font-black mb-4" style={{ color: themeColors.text }}>Technologies Covered in GenAI Course</h2>
                        <p className="max-w-2xl mx-auto text-lg font-medium" style={{ color: themeColors.textMuted }}>Master industry-standard technologies through hands-on practice and real-world project development.</p>
                    </div>

                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
                        {techStack.map((tech, idx) => (
                            <div key={idx} className="bg-white p-8 rounded-2xl border border-slate-100 shadow-sm flex flex-col items-center justify-center text-center transition-all hover:shadow-md hover:-translate-y-1 group">
                                <div className="mb-4 p-3 rounded-xl transition-all duration-300 group-hover:bg-red-50 group-hover:scale-110" style={{ color: themeColors.red }}>
                                    <tech.icon className="w-8 h-8" />
                                </div>
                                <h3 className="font-bold text-base mb-1" style={{ color: themeColors.text }}>{tech.name}</h3>
                                <p className="text-[10px] uppercase tracking-widest font-semibold" style={{ color: themeColors.textLight }}>{tech.category}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── COURSE HIGHLIGHTS ── */}
            <section className="py-12 border-t" style={{ backgroundColor: themeColors.offWhite, borderColor: themeColors.border }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-16">
                        <div className="font-bold text-sm tracking-widest uppercase mb-2 gradient-text">Why Study GenAI?</div>
                        <h2 className="text-3xl md:text-4xl font-black mb-4" style={{ color: themeColors.text }}>Industry-Leading Course Highlights</h2>
                        <p className="max-w-2xl mx-auto text-lg" style={{ color: themeColors.textMuted }}>Master the future of technology with the most comprehensive curriculum in India.</p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {[
                            { icon: GraduationCap, title: 'Industry-First Curriculum', desc: 'Co-designed with hiring managers from Coimbatore & Chennai firms. Updated quarterly for GPT-4o, Claude 3.5, and Llama 3.' },
                            { icon: Rocket, title: 'Build & Deploy Real AI Apps', desc: 'Build 8 production-ready projects like RAG systems and multi-agent workflows. Your GitHub becomes your portfolio.' },
                            { icon: Target, title: '100% Placement Guarantee', desc: 'Dedicated support: resume reviews, unlimited mock interviews, and warm intros to our 500+ hiring partners.' },
                            { icon: Brain, title: 'Trainers Who Build AI', desc: 'Learn from practitioners who have built and deployed LLM products for BFSI, healthcare, and e-commerce clients.' },
                            { icon: MapPin, title: 'Located in RS Puram, Coimbatore', desc: 'Accessible training center at West Lokamanya Street, near bus routes from Gandhipuram, Peelamedu, and more.' },
                            { icon: CalendarDays, title: 'Flexible Batch Options', desc: 'Weekday, weekend, and fast-track batches. Live online options available for students across Tamil Nadu.' },
                        ].map((highlight, idx) => (
                            <div key={idx} className="bg-white border p-8 rounded-2xl transition-all duration-300 red-card group relative overflow-hidden"
                                style={{ borderColor: themeColors.border, boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }}>
                                <div className="absolute top-0 right-0 w-32 h-32 rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity"
                                    style={{ background: 'radial-gradient(circle at top right, rgba(228,59,60,0.05), transparent)' }}></div>
                                <div className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6 relative z-10"
                                    style={{ backgroundColor: themeColors.redBg, border: `1px solid ${themeColors.redBorder}` }}>
                                    <highlight.icon className="w-8 h-8" style={{ color: themeColors.red }} />
                                </div>
                                <h3 className="text-xl font-bold mb-3 relative z-10" style={{ color: themeColors.text }}>{highlight.title}</h3>
                                <p className="text-sm leading-relaxed relative z-10" style={{ color: themeColors.textMuted }}>{highlight.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── SEO MARKETING SECTION ── */}
            <section className="py-12 border-b" style={{ backgroundColor: themeColors.white, borderColor: themeColors.border }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h2 className="text-3xl font-black mb-4" style={{ color: themeColors.text }}>Generative AI Course in Coimbatore with Corporate Internship</h2>
                    <p className="text-lg mb-3" style={{ color: themeColors.textMuted }}>Stay ahead of the curve with PeopleClick's Generative AI Certification. We bridge the gap between theory and real-world deployment.</p>
                    <p className="text-lg mb-5" style={{ color: themeColors.textMuted }}>Learn how to deploy scalable AI agents, optimize LLM inference, and integrate AI into modern workstreams.</p>
                    <a href="#lead-form" onClick={handleScrollToForm} className="inline-block text-white font-bold py-3 px-6 rounded-lg shadow-lg hover:opacity-90 transition-opacity"
                        style={{ background: themeColors.gradientRed }}>Enroll in the Next AI Batch</a>

                    <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="border p-6 rounded-2xl" style={{ borderColor: themeColors.border, backgroundColor: themeColors.offWhite }}>
                            <h3 className="text-xl font-bold mb-3" style={{ color: themeColors.text }}>How to Become a GenAI Professional</h3>
                            <ol className="list-decimal list-inside space-y-4" style={{ color: themeColors.textMuted }}>
                                <li>
                                    <strong style={{ color: themeColors.text }}>Build AI Agents, not just Chatbots</strong>
                                    <p className="mt-2 text-sm leading-relaxed">Companies want autonomous systems. We teach you to build agents that can think, plan, and execute using external tools.</p>
                                    <p className="mt-2 font-semibold gradient-text">Result: Become an AI Automation Expert</p>
                                </li>
                                <li>
                                    <strong style={{ color: themeColors.text }}>Master the Vector Stack</strong>
                                    <p className="mt-2 text-sm leading-relaxed">Retrieval Augmented Generation (RAG) is the gold standard for enterprise AI. Master embedding models and vector search.</p>
                                    <p className="mt-2 font-semibold gradient-text">Result: Build factual, production-ready AI apps</p>
                                </li>
                                <li>
                                    <strong style={{ color: themeColors.text }}>Portfolio: Building for Industry</strong>
                                    <p className="mt-2 text-sm leading-relaxed">You'll build a Customer Service Agent, an Automated Research tool, and a custom RAG system for a document library.</p>
                                    <p className="mt-2 font-semibold gradient-text">Result: Industry-ready AI Github profile</p>
                                </li>
                                <li>
                                    <strong style={{ color: themeColors.text }}>Get Internship Ready</strong>
                                    <p className="mt-2 text-sm leading-relaxed">We don't just teach; we provide you with a role in our IT division for high-performing students.</p>
                                    <p className="mt-2 font-semibold gradient-text">Result: Real experience on your Resume</p>
                                </li>
                            </ol>
                        </div>

                        <div className="border p-6 rounded-2xl" style={{ borderColor: themeColors.border, backgroundColor: themeColors.offWhite }}>
                            <h3 className="text-xl font-bold mb-3" style={{ color: themeColors.text }}>The Best GenAI Course in Coimbatore</h3>
                            <p className="text-sm mb-4 leading-relaxed" style={{ color: themeColors.textMuted }}>
                                PeopleClick Learning's Generative AI & LLM Training in Coimbatore is the most comprehensive, industry-aligned AI program available in Tamil Nadu. Built around Large Language Model development, Prompt Engineering, RAG pipelines, and Agentic AI systems.
                            </p>
                            <h3 className="text-xl font-bold mt-8 mb-3" style={{ color: themeColors.text }}>Primary Tech Stack</h3>
                            <div className="flex flex-wrap gap-2">
                                {[
                                    'GPT-4o', 'Claude 3.5', 'Llama 3.1', 'Gemini 1.5', 'LangChain', 'LangGraph',
                                    'CrewAI', 'AutoGen', 'Pinecone', 'ChromaDB', 'Hugging Face', 'QLoRA',
                                    'FastAPI', 'Streamlit', 'Docker', 'AWS Bedrock'
                                ].map((tech, i) => (
                                    <span key={i} className="text-[10px] font-bold px-2 py-1 rounded bg-white border" style={{ borderColor: themeColors.border, color: themeColors.text }}>{tech}</span>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="mt-10">
                        <h3 className="text-2xl font-black mb-4" style={{ color: themeColors.text }}>Generative AI Course Roadmap</h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" style={{ color: themeColors.textMuted }}>
                            <div className="flex flex-col md:items-center">
                                <div>
                                    <p className="font-bold mb-2 text-left" style={{ color: themeColors.text }}>Core AI Modules</p>
                                    <ul className="list-disc list-inside space-y-1 text-sm text-left">
                                        <li>Tokenization & Embeddings Deep Dive</li>
                                        <li>Semantic Search vs Vector Retrieval</li>
                                        <li>Advanced Prompting (Chain-of-thought, Tree-of-thought)</li>
                                        <li>LangChain: Chains, Memory & Tools</li>
                                        <li>RAG vs Fine-Tuning: Decision Matrix</li>
                                        <li>Fine-tuning with LoRA & QLoRA</li>
                                        <li>LLM Evaluation & Benchmarking</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="flex flex-col md:items-center">
                                <div>
                                    <p className="font-bold mb-2 text-left" style={{ color: themeColors.text }}>Capstone Projects</p>
                                    <ul className="list-disc list-inside space-y-1 text-sm text-left">
                                        <li>Enterprise RAG for PDF/Doc Libraries</li>
                                        <li>Task-oriented Autonomous AI Research Agent</li>
                                        <li>Custom Chat-with-SQL Database Interface</li>
                                        <li>Multi-Agent Sales Workflow Simulator</li>
                                        <li>End-to-End LLM Deployment (Gradio + FastAPI)</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ── OUTCOMES STRIP ── */}
            <div className="border-y py-12 relative overflow-hidden" style={{ backgroundColor: themeColors.offWhite, borderColor: themeColors.border }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="relative w-full overflow-hidden pb-4">
                        <div className="flex w-max animate-infinite-scroll">
                            {[1, 2].map((_, duplicateIndex) => (
                                <div key={duplicateIndex} className="flex gap-6 pr-6">
                                    {[
                                        { val: '20+', label: 'AI Projects Completed' },
                                        { val: '100%', label: 'Placement Assistance' },
                                        { val: 'Top 5%', label: 'Get High-Performance Internship' },
                                        { val: '12+', label: 'LLM Frameworks Mastered' },
                                        { val: '24/7', label: 'LMS & AI Sandbox Access' },
                                    ].map((stat, i) => (
                                        <div key={`${duplicateIndex}-${i}`} className="p-6 rounded-2xl bg-white border transition-all hover:scale-105 min-w-[200px] md:min-w-[260px] flex-shrink-0 text-center"
                                            style={{ borderColor: themeColors.border, boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }}>
                                            <div className="text-3xl md:text-4xl font-black mb-2 gradient-text">{stat.val}</div>
                                            <div className="text-sm font-medium leading-tight whitespace-normal max-w-[220px] mx-auto" style={{ color: themeColors.textMuted }}>{stat.label}</div>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* ── CURRICULUM SECTION ── */}
            <section className="py-20 section-reveal" style={{ backgroundColor: themeColors.white }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="mb-12 text-center">
                        <div className="font-bold text-sm tracking-widest uppercase mb-2 gradient-text">Curriculum</div>
                        <h2 className="text-3xl md:text-4xl font-black mb-4" style={{ color: themeColors.text }}>GenAI Certification Syllabus</h2>
                        <p className="max-w-2xl mx-auto text-lg" style={{ color: themeColors.textMuted }}>Designed by AI Architects from top tier product firms to ensure you are industry ready.</p>
                    </div>

                    {/* Mobile View: Grid Layout */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 lg:hidden">
                        {[
                            { num: '01', icon: Terminal, title: 'Python & AI Foundations', desc: 'Advanced OOP, async Python, NumPy, Pandas, and Neural Network fundamentals.', tags: ['Python', 'PyTorch'] },
                            { num: '02', icon: Globe, title: 'NLP & Transformers', desc: 'Attention mechanism, Self-attention, BERT vs GPT, and HuggingFace mastery.', tags: ['Transformers', 'NLP'] },
                            { num: '03', icon: Brain, title: 'LLM Deep Dive', desc: 'GPT-4, Claude 3.5, Llama 3, Gemini. Token limits, context windows, and pricing.', tags: ['GPT-4', 'Llama 3'] },
                            { num: '04', icon: Zap, title: 'Prompt Engineering', desc: 'Zero/Few-shot, CoT, ReAct, and Prompt evaluation frameworks like PromptFoo.', tags: ['Prompt Mastery'] },
                            { num: '05', icon: Link, title: 'LangChain & RAG', desc: 'Vector DBs (Pinecone/Chroma), Hybrid Search, and advanced RAG pipelines.', tags: ['LangChain', 'RAG'] },
                            { num: '06', icon: Chip, title: 'Fine-tuning & RLHF', desc: 'Domain customization using LoRA, QLoRA, and Direct Preference Optimization.', tags: ['PEFT', 'SFT'] },
                            { num: '07', icon: Bot, title: 'Agentic AI Systems', desc: 'Multi-agent frameworks with CrewAI & AutoGen. Autonomous task planning.', tags: ['CrewAI', 'Agents'] },
                            { num: '08', icon: Rocket, title: 'Deployment & MLOps', desc: 'FastAPI, Streamlit, Docker, and CI/CD for production-grade AI applications.', tags: ['MLOps', 'AWS'] },
                        ].map((mod, i) => (
                            <div key={i} className="bg-white border p-6 rounded-2xl transition-all red-card group"
                                style={{ borderColor: themeColors.border, boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }}>
                                <div className="text-center">
                                    <div className="mx-auto w-12 h-12 rounded-xl flex items-center justify-center font-black mb-4 text-white relative group-hover:scale-110 transition-transform"
                                        style={{ background: themeColors.gradientRed }}>
                                        <mod.icon className="w-6 h-6" />
                                        <span className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-white border border-red-100 flex items-center justify-center text-[10px] font-bold" style={{ color: themeColors.red }}>{mod.num}</span>
                                    </div>
                                    <h3 className="text-base font-bold mb-2 leading-tight" style={{ color: themeColors.text }}>{mod.title}</h3>
                                    <p className="text-xs mb-4 min-h-[40px]" style={{ color: themeColors.textMuted }}>{mod.desc}</p>
                                    <div className="flex flex-wrap justify-center gap-1">
                                        {mod.tags.map(tag => (
                                            <span key={tag} className="text-[10px] font-bold px-2 py-0.5 rounded bg-gray-50 border border-gray-100"
                                                style={{ color: themeColors.red }}>
                                                {tag}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Desktop View: Circular Hub Layout */}
                    <div className="hidden lg:flex relative w-full max-w-5xl mx-auto h-[800px] items-center justify-center">
                        {/* Center Hub */}
                        <div className="relative z-20 w-48 h-48 rounded-full shadow-2xl flex flex-col items-center justify-center text-center p-4"
                            style={{ background: themeColors.gradientRed, border: '4px solid white', boxShadow: '0 10px 40px rgba(238, 47, 68, 0.3)' }}>
                            <div className="absolute inset-0 rounded-full animate-ping opacity-20" style={{ background: themeColors.gradientRed }}></div>
                            <h3 className="text-white font-black text-2xl leading-tight">GenAI<br />Curriculum</h3>
                        </div>

                        {/* Nodes & Lines */}
                        <div className="absolute top-1/2 left-1/2 w-0 h-0 animate-spin-slow">
                            {[
                                { num: '01', icon: Terminal, title: 'Python & AI Foundations', desc: 'Advanced OOP, async Python, NumPy, Pandas, and Neural Network fundamentals.' },
                                { num: '02', icon: Globe, title: 'NLP & Transformers', desc: 'Attention mechanism, Self-attention, BERT vs GPT, and HuggingFace mastery.' },
                                { num: '03', icon: Brain, title: 'LLM Deep Dive', desc: 'GPT-4, Claude 3.5, Llama 3, Gemini. Token limits, context windows, and pricing.' },
                                { num: '04', icon: Zap, title: 'Prompt Engineering', desc: 'Zero/Few-shot, CoT, ReAct, and Prompt evaluation frameworks like PromptFoo.' },
                                { num: '05', icon: Link, title: 'LangChain & RAG', desc: 'Vector DBs (Pinecone/Chroma), Hybrid Search, and advanced RAG pipelines.' },
                                { num: '06', icon: Chip, title: 'Fine-tuning & RLHF', desc: 'Domain customization using LoRA, QLoRA, and Direct Preference Optimization.' },
                                { num: '07', icon: Bot, title: 'Agentic AI Systems', desc: 'Multi-agent frameworks with CrewAI & AutoGen. Autonomous task planning.' },
                                { num: '08', icon: Rocket, title: 'Deployment & MLOps', desc: 'FastAPI, Streamlit, Docker, and CI/CD for production-grade AI applications.' },
                            ].map((mod, i) => {
                                const angle = i * 45 - 90; // Start at top
                                const radius = 300;
                                return (
                                    <div key={i} className="contents">
                                        {/* Connecting Line */}
                                        {/* <div className="absolute top-1/2 left-1/2 h-[2px] z-0 origin-left" 
                                             style={{ 
                                                 width: `${radius}px`, 
                                                 transform: `translateY(-50%) rotate(${angle}deg)`,
                                                 backgroundColor: themeColors.redBorder 
                                             }}>
                                        </div> */}

                                        {/* Node */}
                                        <div className="absolute top-1/2 left-1/2 z-10 transition-transform duration-300 hover:scale-110 cursor-default group"
                                            style={{ transform: `translate(-50%, -50%) rotate(${angle}deg) translateX(${radius}px) rotate(${-angle}deg)` }}>

                                            <div className="animate-spin-reverse-slow">
                                                <div className="w-40 h-40 rounded-full bg-white shadow-xl flex flex-col items-center justify-center text-center p-3 relative"
                                                    style={{ border: `3px solid ${themeColors.redBg}` }}>

                                                    {/* Number Badge */}
                                                    <div className="absolute top-0 right-0 w-8 h-8 rounded-full text-white font-bold flex items-center justify-center text-xs shadow-md"
                                                        style={{ background: themeColors.gradientRed, transform: 'translate(20%, -20%)' }}>
                                                        {mod.num}
                                                    </div>

                                                    <div className="w-10 h-10 rounded-full flex items-center justify-center mb-1 group-hover:scale-110 transition-transform"
                                                        style={{ backgroundColor: themeColors.redBg }}>
                                                        <mod.icon className="w-5 h-5" style={{ color: themeColors.red }} />
                                                    </div>

                                                    <h3 className="text-sm font-black leading-tight mb-1" style={{ color: themeColors.text }}>{mod.title}</h3>
                                                    <p className="text-[9px] leading-tight text-gray-500 line-clamp-3">{mod.desc}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </section>

            {/* ── CERTIFICATIONS SECTION ── */}
            <section className="py-20 border-t section-reveal" style={{ backgroundColor: themeColors.offWhite, borderColor: themeColors.border }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-16">
                        <div className="font-bold text-sm tracking-widest uppercase mb-2 gradient-text">Global Recognition</div>
                        <h2 className="text-3xl md:text-4xl font-black mb-4" style={{ color: themeColors.text }}>Industry-Leading Certifications</h2>
                        <p className="max-w-2xl mx-auto text-lg" style={{ color: themeColors.textMuted }}>Earn globally recognized credentials that validate your expertise in Artificial Intelligence across technical and professional domains.</p>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                        {/* Technical Certifications */}
                        <div className="bg-white border p-8 rounded-3xl relative overflow-hidden group hover:shadow-2xl transition-all duration-500 hover:-translate-y-1"
                            style={{ borderColor: themeColors.border, boxShadow: '0 4px 20px rgba(0,0,0,0.03)' }}>
                            <div className="absolute top-0 right-0 w-64 h-64 rounded-bl-full opacity-50 group-hover:scale-110 transition-transform duration-700 pointer-events-none" style={{ backgroundColor: themeColors.redBg }}></div>

                            <div className="relative z-10">
                                <div className="flex items-center gap-4 mb-8">
                                    <div className="w-16 h-16 rounded-2xl flex items-center justify-center shadow-inner" style={{ backgroundColor: themeColors.redBg, border: `1px solid ${themeColors.redBorder}` }}>
                                        <Cpu className="w-8 h-8" style={{ color: themeColors.red }} />
                                    </div>
                                    <div>
                                        <h3 className="text-2xl font-black" style={{ color: themeColors.text }}>Technical Certifications</h3>
                                        <p className="text-sm font-medium uppercase tracking-wider" style={{ color: themeColors.red }}>For Builders & Engineers</p>
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                    {[
                                        'AI+ Developer™', 'AI+ Engineer™', 'AI+ Prompt Engineer Level 2™',
                                        'AI+ Architect Practitioner™', 'AI+ Cloud Practitioner™', 'AI+ Data Practitioner™',
                                        'AI+ Robotics Practitioner™', 'AI+ Ethical Hacker™', 'AI+ Security Compliance™', 'AI+ Security Level 1, 2 & 3™'
                                    ].map((cert, i) => (
                                        <div key={i} className="flex items-start gap-3 p-3 rounded-xl hover:bg-slate-50 transition-colors border border-transparent hover:border-slate-200 group/item">
                                            <div className="mt-0.5 group-hover/item:scale-110 transition-transform"><CheckIcon /></div>
                                            <span className="font-semibold text-sm leading-tight" style={{ color: themeColors.text }}>{cert}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Professional Certifications */}
                        <div className="bg-white border p-8 rounded-3xl relative overflow-hidden group hover:shadow-2xl transition-all duration-500 hover:-translate-y-1"
                            style={{ borderColor: themeColors.border, boxShadow: '0 4px 20px rgba(0,0,0,0.03)' }}>
                            <div className="absolute top-0 right-0 w-64 h-64 bg-slate-50 rounded-bl-full opacity-50 group-hover:scale-110 transition-transform duration-700 pointer-events-none"></div>

                            <div className="relative z-10">
                                <div className="flex items-center gap-4 mb-8">
                                    <div className="w-16 h-16 rounded-2xl flex items-center justify-center shadow-inner bg-slate-50 border border-slate-100">
                                        <Building className="w-8 h-8 text-slate-700" />
                                    </div>
                                    <div>
                                        <h3 className="text-2xl font-black" style={{ color: themeColors.text }}>Professional Certifications</h3>
                                        <p className="text-sm font-medium uppercase tracking-wider text-slate-500">For Leaders & Specialists</p>
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                    {[
                                        'AI+ Foundation™', 'AI+ Executive Fundamentals™', 'AI+ Prompting Fundamentals™',
                                        'AI+ Everyone Fundamentals™', 'AI+ Marketing Practitioner™', 'AI+ Sales Practitioner™',
                                        'AI+ Educator Practitioner™', 'AI+ Chief AI Officer™', 'AI+ Finance Practitioner™',
                                        'AI+ Human Resources Practitioner™', 'AI+ Product Manager Fundamentals™', 'AI+ Ethics Fundamentals™', 'AI+ Healthcare Fundamentals™'
                                    ].map((cert, i) => (
                                        <div key={i} className="flex items-start gap-3 p-3 rounded-xl hover:bg-slate-50 transition-colors border border-transparent hover:border-slate-200 group/item">
                                            <div className="mt-0.5 group-hover/item:scale-110 transition-transform"><CheckIcon /></div>
                                            <span className="font-semibold text-sm leading-tight" style={{ color: themeColors.text }}>{cert}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ── WHO SHOULD JOIN ── */}
            <section className="py-20 border-t" style={{ backgroundColor: themeColors.offWhite, borderColor: themeColors.border }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-16">
                        <div className="font-bold text-sm tracking-widest uppercase mb-2 gradient-text">Target Audience</div>
                        <h2 className="text-3xl md:text-4xl font-black mb-4" style={{ color: themeColors.text }}>Is this AI Course for You?</h2>
                        <p className="max-w-2xl mx-auto text-lg" style={{ color: themeColors.textMuted }}>GenAI is transforming every role. Join us to become the AI champion of your organization.</p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {[
                            { icon: Code, title: 'Developers', desc: 'Engineers looking to build and deploy LLM powered applications and AI features.' },
                            { icon: TrendingUp, title: 'Career Pivoters', desc: 'Professionals looking to move into high-paying AI Engineer or Data Science roles.' },
                            { icon: Brain, title: 'Data Scientists', desc: 'Existing analysts looking to transition from traditional ML to Generative AI stacks.' },
                            { icon: Building, title: 'Tech Leaders', desc: 'Architects and Managers who need to understand GenAI capabilities to lead AI initiatives.' },
                            { icon: GraduationCap, title: 'Recent Graduates', desc: 'Students looking to start their career right at the bleeding edge of technology.' },
                            { icon: Sparkles, title: 'Problem Solvers', desc: 'Anyone fascinated by the power of AI who wants to learn building real value-driven tools.' },
                        ].map((item, i) => {
                            const Icon = item.icon;
                            return (
                                <div key={i} className="bg-white border p-8 rounded-2xl red-card transition-all group text-left"
                                    style={{ borderColor: themeColors.border, boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }}>
                                    <div className="mb-4 group-hover:scale-110 transition-transform w-16 h-16 flex items-center justify-center rounded-2xl"
                                        style={{ backgroundColor: themeColors.redBg }}>
                                        <Icon className="w-10 h-10" style={{ color: themeColors.red }} />
                                    </div>
                                    <h3 className="text-xl font-bold mb-3" style={{ color: themeColors.text }}>{item.title}</h3>
                                    <p className="text-sm leading-relaxed" style={{ color: themeColors.textMuted }}>{item.desc}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* ── JOB ROLES ── */}
            <section className="py-20 section-reveal" style={{ backgroundColor: themeColors.white }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-16">
                        <div className="font-bold text-sm tracking-widest uppercase mb-2 gradient-text">Career Outcomes</div>
                        <h2 className="text-3xl md:text-4xl font-black mb-4" style={{ color: themeColors.text }}>Emerging Job Roles in AI</h2>
                        <p className="max-w-2xl mx-auto text-lg" style={{ color: themeColors.textMuted }}>Explore the most in-demand roles in the current and future tech landscape.</p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {[
                            { title: 'Generative AI Engineer', salary: '₹10-18 LPA', desc: 'Highest demand in 2026. Design and deploy LLM applications using LangChain and RAG.' },
                            { title: 'LLM App Developer', salary: '₹8-14 LPA', desc: 'LangChain + RAG specialists needed for enterprise automation and chatbots.' },
                            { title: 'Prompt Engineer', salary: '₹6-10 LPA', desc: 'Optimizing model outcomes through expert prompting and evaluation techniques.' },
                            { title: 'AI Architect (Sr.)', salary: '₹25-40 LPA', desc: 'Strategizing enterprise-wide AI integrations and multi-agent system design.' },
                            { title: 'MLOps Engineer', salary: '₹12-25 LPA', desc: 'Deploying, monitoring, and scaling large language models in production.' },
                            { title: 'AI Consultant', salary: '₹12-30 LPA', desc: 'Helping businesses pivot to AI-first workflows using autonomous agents.' },
                        ].map((role, i) => (
                            <div key={i} className="bg-white border p-6 rounded-2xl red-card transition-all group"
                                style={{ borderColor: themeColors.border, boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }}>
                                <div className="flex justify-between items-start mb-4">
                                    <h3 className="text-lg font-bold leading-tight" style={{ color: themeColors.text }}>{role.title}</h3>
                                    <span className="text-xs font-black px-2 py-1 rounded-md border whitespace-nowrap bg-red-50 border-red-100 text-red-600">
                                        {role.salary}
                                    </span>
                                </div>
                                <p className="text-sm leading-relaxed" style={{ color: themeColors.textMuted }}>{role.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── INDUSTRIAL PROJECTS ── */}
            <section className="py-20 border-t" style={{ backgroundColor: themeColors.white, borderColor: themeColors.border }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-16">
                        <div className="font-bold text-sm tracking-widest uppercase mb-2 gradient-text">Hands-On Experience</div>
                        <h2 className="text-3xl md:text-4xl font-black mb-4" style={{ color: themeColors.text }}>Build 8 Industrial AI Products</h2>
                        <p className="max-w-2xl mx-auto text-lg" style={{ color: themeColors.textMuted }}>You don't just learn theory. You build and deploy real-world AI applications that businesses need today.</p>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {[
                            { icon: ClipboardList, title: 'Clinical Trial Reporter', tech: 'RAG + Medical LLMs', desc: 'Automate reporting for medical clinical trials with high factual accuracy.' },
                            { icon: FileText, title: 'Legal Doc Summarizer', tech: 'Long Context LLMs', desc: 'Summarize 100+ page legal documents while preserving all critical clauses.' },
                            { icon: TrendingUp, title: 'AI Financial Advisor', tech: 'RAG + SQL Search', desc: 'Secure bot that analyzes market trends and personal portfolios for advice.' },
                            { icon: GraduationCap, title: 'Edu-Bot Tutor', tech: 'Multi-Agent Logic', desc: 'Personalized learning paths for students based on their progress and style.' },
                            { icon: UserCheck, title: 'Smart Resume Scorer', tech: 'NLP + Embeddings', desc: 'Screen resumes against complex job descriptions with semantic matching.' },
                            { icon: Music, title: 'Podcast Search Engine', tech: 'Audio-to-Text RAG', desc: 'Query long-form video/audio transcripts and get exact timestamps.' },
                            { icon: Search, title: 'Natural Language SQL', tech: 'Text-to-SQL + Agents', desc: 'Allow non-tech managers to query company databases using simple English.' },
                            { icon: Eye, title: 'Visual Product Inspector', tech: 'Multimodal Vision AI', desc: 'Detect defects in manufacturing items using GPT-4 Vision and Gemini Pro.' },
                        ].map((project, i) => {
                            const Icon = project.icon;
                            return (
                                <div key={i} className="bg-white border p-8 rounded-2xl red-card transition-all group text-left relative overflow-hidden"
                                    style={{ borderColor: themeColors.border, boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }}>
                                    <div className="mb-4 group-hover:scale-110 transition-transform w-16 h-16 flex items-center justify-center rounded-2xl"
                                        style={{ backgroundColor: themeColors.redBg }}>
                                        <Icon className="w-10 h-10" style={{ color: themeColors.red }} />
                                    </div>
                                    <div className="text-xs font-black uppercase tracking-widest mb-2" style={{ color: themeColors.red }}>{project.tech}</div>
                                    <h3 className="text-xl font-bold mb-3" style={{ color: themeColors.text }}>{project.title}</h3>
                                    <p className="text-sm leading-relaxed" style={{ color: themeColors.textMuted }}>{project.desc}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* ── TECH STACK COVERED ── */}
            <section className="py-20 border-t" style={{ backgroundColor: themeColors.offWhite, borderColor: themeColors.border }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-16">
                        <div className="font-bold text-sm tracking-widest uppercase mb-2 gradient-text">Tech Ecosystem</div>
                        <h2 className="text-3xl md:text-4xl font-black mb-4" style={{ color: themeColors.text }}>Industry Tools You'll Master</h2>
                        <p className="max-w-2xl mx-auto text-lg" style={{ color: themeColors.textMuted }}>We teach the full AI stack that's currently powering the world's most innovative companies.</p>
                    </div>

                    <div ref={toolsRef} className="flex gap-5 overflow-x-auto pb-2 md:grid md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 md:overflow-visible md:pb-0 snap-x snap-mandatory scrollbar-thin">
                        {[
                            { name: 'OpenAI / GPT-4', icon: Sparkles, desc: 'Primary SOTA Model' },
                            { name: 'LangChain', icon: Layers, desc: 'AI Orchestration' },
                            { name: 'LangGraph', icon: Globe, desc: 'Multi-Agent Logic' },
                            { name: 'Pinecone', icon: Database, desc: 'Vector Database' },
                            { name: 'Hugging Face', icon: Cpu, desc: 'Model Hub' },
                            { name: 'ChromaDB', icon: Target, desc: 'OS Vector Store' },
                            { name: 'Claude / Gemini', icon: Chip, desc: 'Model Ecosystem' },
                            { name: 'PyTorch', icon: Terminal, desc: 'AI Framework' },
                            { name: 'Llama 3', icon: Brain, desc: 'OS Model Expert' },
                            { name: 'Vercel AI SDK', icon: Zap, desc: 'Frontend AI Dev' },
                        ].map((tool, i) => (
                            <div key={i} className="min-w-[220px] md:min-w-0 flex-shrink-0 md:flex-shrink md:mx-0 rounded-2xl p-6 glass-card transition-all group text-center snap-start"
                                style={{ boxShadow: '0 4px 15px rgba(0,0,0,0.03)' }}>
                                <div className="mb-4 p-3 w-16 h-16 mx-auto flex items-center justify-center rounded-2xl transition-all group-hover:scale-110 group-hover:bg-red-50" style={{ backgroundColor: themeColors.redBg }}>
                                    <tool.icon className="w-10 h-10" style={{ color: themeColors.red }} />
                                </div>
                                <h3 className="text-lg font-bold mb-2" style={{ color: themeColors.text }}>{tool.name}</h3>
                                <p className="text-xs font-medium uppercase tracking-wider" style={{ color: themeColors.textLight }}>{tool.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── WHY CHOOSE PEOPLECLICK & INTERNSHIP ── */}
            <section id="internship-section" className="py-20 border-t scroll-mt-20" style={{ backgroundColor: themeColors.white, borderColor: themeColors.border }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

                        {/* Left: Content */}
                        <div className="order-2 lg:order-1 text-left">
                            <div className="font-bold text-sm tracking-widest uppercase mb-2 gradient-text">Exclusive Benefit</div>
                            <h2 className="text-3xl md:text-5xl font-black mb-6 leading-tight" style={{ color: themeColors.text }}>AI Career Accelerator</h2>
                            <p className="text-lg mb-6 leading-relaxed" style={{ color: themeColors.textMuted }}>
                                The AI market is moving too fast for classroom-only learning. We provide dedicated students the opportunity for a <strong style={{ color: themeColors.text }}>Tier-1 AI Internship</strong> in our corporate AI Solutions Lab.
                            </p>

                            <ul className="space-y-4 mb-8">
                                {[
                                    { title: 'Real LLM Deployment', desc: 'Work on actual Enterprise RAG and Agent systems being used by our clients today.' },
                                    { title: 'Hiring Referral Network', desc: 'Direct job referrals to our network of 500+ Hiring Partners in Bangalore and Coimbatore.' },
                                    { title: 'AI Lab Experience', desc: 'Learn to use professional toolsets for observability (LangSmith/Weights & Biases) and evaluation.' },
                                ].map((item, i) => (
                                    <li key={i} className="flex items-start gap-3">
                                        <div className="mt-1 p-1 rounded-full" style={{ backgroundColor: themeColors.redBg }}><CheckIcon /></div>
                                        <div>
                                            <h4 className="font-bold mb-1" style={{ color: themeColors.text }}>{item.title}</h4>
                                            <p className="text-sm" style={{ color: themeColors.textMuted }}>{item.desc}</p>
                                        </div>
                                    </li>
                                ))}
                            </ul>

                            <a href="#lead-form" onClick={handleScrollToForm} className="inline-block text-white font-bold py-3 px-8 rounded-lg transition-all hover:-translate-y-1"
                                style={{ background: themeColors.gradientRed, boxShadow: '0 4px 20px rgba(238, 47, 68,0.35)' }}>
                                Apply for Internship Eligibility
                            </a>
                        </div>

                        {/* Right: Image */}
                        <div className="order-1 lg:order-2 relative">
                            <div className="absolute inset-0 rounded-2xl blur-2xl" style={{ background: 'radial-gradient(circle, rgba(238, 47, 68,0.12), transparent 70%)' }}></div>
                            <div className="relative rounded-2xl overflow-hidden shadow-2xl border transform rotate-1 hover:rotate-0 transition-transform duration-500 group"
                                style={{ borderColor: themeColors.border }}>
                                <img src={`${process.env.PUBLIC_URL}/genai_internship.png`} alt="Real-time Industrial Internship" className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-700" />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
                                <div className="absolute bottom-6 left-6 right-6">
                                    <div className="bg-white/90 backdrop-blur-md p-4 rounded-xl shadow-lg inline-block border" style={{ borderColor: themeColors.border }}>
                                        <div className="flex items-center gap-3">
                                            <Sparkles className="w-8 h-8" color={themeColors.red} />
                                            <div>
                                                <div className="font-bold" style={{ color: themeColors.text }}>GenAI Solutions Lab</div>
                                                <div className="text-xs" style={{ color: themeColors.textMuted }}>Industrial Internship Partner</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>


            {/* ── BATCH & PRICING CTA ── */}
            <section className="pt-10 pb-24 relative overflow-hidden" style={{ backgroundColor: themeColors.white }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

                        <div>
                            <div className="font-bold text-sm tracking-widest uppercase mb-2 gradient-text text-left">Next Batch Starting Soon</div>
                            <h2 className="text-3xl md:text-5xl font-black mb-6 text-left" style={{ color: themeColors.text }}>AI Won't Replace You, Someone Using AI Will.</h2>
                            <p className="text-lg mb-8 text-left" style={{ color: themeColors.textMuted }}>Don't let the AI revolution pass you by. Secure your future in the highest paying tech segment.</p>

                            <div className="space-y-4">
                                <div className="border-2 p-5 rounded-xl flex justify-between items-center"
                                    style={{ borderColor: themeColors.red, backgroundColor: 'rgba(238, 47, 68,0.04)' }}>
                                    <div>
                                        <h4 className="font-bold mb-1 flex items-center gap-2" style={{ color: themeColors.text }}>
                                            <CalendarDays className="w-5 h-5" color={themeColors.red} /> GENAI BATCH ENROLLMENT
                                        </h4>
                                        <p className="text-xs tracking-wide" style={{ color: themeColors.textMuted }}>OPENING THIS WEEK — LIMITED SEATS</p>
                                    </div>
                                    <span className="text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap"
                                        style={{ backgroundColor: 'rgba(238, 47, 68,0.1)', borderColor: themeColors.redBorder, border: `1px solid ${themeColors.redBorder}` }}>
                                        <span className="gradient-text">Filling Fast</span>
                                    </span>
                                </div>
                            </div>

                            <div className="mt-10 flex flex-wrap gap-4">
                                <a href="#lead-form" onClick={handleScrollToForm} className="text-white font-bold py-4 px-8 rounded-lg transition-transform hover:scale-105"
                                    style={{ background: themeColors.gradientRed, boxShadow: '0 4px 14px rgba(238, 47, 68,0.35)' }}>
                                    Secure My Free Slot
                                </a>
                                <a href="tel:+918925887264" className="border font-bold py-4 px-8 rounded-lg transition-colors flex items-center gap-2"
                                    style={{ borderColor: themeColors.border, color: themeColors.text }}>
                                    <Phone className="w-5 h-5" color={themeColors.red} /> Call Counselor
                                </a>
                            </div>
                        </div>

                        {/* Pricing Card */}
                        <div className="bg-white border-2 p-8 sm:p-10 rounded-3xl relative max-w-md mx-auto w-full shadow-xl"
                            style={{ borderColor: themeColors.red, boxShadow: '0 8px 40px rgba(238, 47, 68,0.15)' }}>
                            <div className="absolute top-0 right-10 -translate-y-1/2 text-xs font-bold px-4 py-1.5 rounded-full shadow-lg text-white"
                                style={{ background: themeColors.gradientRed }}>
                                EARLY BIRD PRICING
                            </div>

                            <div className="text-center mb-8">
                                <h3 className="text-2xl font-bold mb-2" style={{ color: themeColors.text }}>GenAI Masterclass</h3>
                                <p className="text-sm" style={{ color: themeColors.textMuted }}>End-to-End Artificial Intelligence Roadmap.</p>
                            </div>

                            <ul className="space-y-4 mb-8">
                                {[
                                    '4 Months Certification Program',
                                    '20+ Real-World AI Projects',
                                    'Prompt Engineering Mastery Pack',
                                    '100% Placement Referral Support',
                                    'Exclusive AI Lab Access',
                                    'Recorded Classes for Lifetime Ref.'
                                ].map((item, i) => (
                                    <li key={i} className="flex items-start gap-3 text-sm" style={{ color: themeColors.textMuted }}>
                                        <span className="mt-0.5"><CheckIcon /></span>
                                        {item}
                                    </li>
                                ))}
                            </ul>

                            <a href="#lead-form" onClick={handleScrollToForm} className="block text-center w-full text-white font-bold py-4 px-6 rounded-xl hover:opacity-90 transition-opacity"
                                style={{ background: themeColors.gradientRed }}>
                                Check Current Best Offer →
                            </a>
                            <p className="text-center text-xs mt-4 flex items-center justify-center gap-1" style={{ color: themeColors.textLight }}>
                                <CreditCard className="w-3 h-3" /> No-Cost EMI Available
                            </p>
                        </div>

                    </div>
                </div>
            </section>

            {/* ── SEO CONTENT GUIDE ── */}
            <section className="py-20 border-t text-left" style={{ backgroundColor: themeColors.white, borderColor: themeColors.border, textAlign: 'left' }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="max-w-4xl text-left w-full" style={{ textAlign: 'left' }}>
                        <h2 className="text-2xl md:text-3xl font-black mb-6" style={{ color: themeColors.text }}>Generative AI & LLM Training in Coimbatore — Complete Guide</h2>
                        <p className="text-base md:text-lg mb-8 leading-relaxed" style={{ color: themeColors.textMuted }}>
                            If you're searching for the best Generative AI course in Coimbatore or an LLM training institute in Coimbatore, this guide answers everything you need to know before enrolling.
                        </p>

                        <h3 className="text-xl font-bold mb-4" style={{ color: themeColors.text }}>What is Generative AI?</h3>
                        <p className="text-base mb-8 leading-relaxed" style={{ color: themeColors.textMuted }}>
                            Generative AI (Gen AI) refers to artificial intelligence systems capable of creating new content — text, code, images, audio, and video — rather than simply analyzing data. The underlying technology in text-based Gen AI is the Large Language Model (LLM) — a neural network trained on billions of words to understand and generate human language.
                        </p>

                        <h3 className="text-xl font-bold mb-4" style={{ color: themeColors.text }}>Why Learn Gen AI & LLMs in 2026?</h3>
                        <p className="text-base mb-8 leading-relaxed" style={{ color: themeColors.textMuted }}>
                            In India, job postings requiring Generative AI skills grew by over 400% in 2024–2025. Coimbatore's tech corridor — with companies like Zoho, KGISL, and hundreds of IT service firms — is actively hiring Gen AI talent. Freshers with LLM skills are being offered ₹6–10 LPA, while experienced engineers cmd ₹14–25 LPA.
                        </p>

                        <h3 className="text-xl font-bold mb-4" style={{ color: themeColors.text }}>How is PeopleClick's Training Different?</h3>
                        <p className="text-base leading-relaxed" style={{ color: themeColors.textMuted }}>
                            While many institutes offer introductory courses, PeopleClick Learning differentiates through shipping working code, training by active practitioners, and unlimited placement support until you land your dream role.
                        </p>
                    </div>
                </div>
            </section>

            <section className="py-20 border-t" style={{ backgroundColor: themeColors.white, borderColor: themeColors.border }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="mt-10 border p-6 rounded-2xl text-left" style={{ borderColor: themeColors.border, backgroundColor: themeColors.offWhite }}>
                        <h3 className="text-2xl font-black mb-6" style={{ color: themeColors.text }}>Frequently Asked Questions (FAQ)</h3>
                        <div className="space-y-4">
                            {[
                                { q: "What is the fee for Generative AI & LLM training in Coimbatore at PeopleClick?", a: "Contact PeopleClick Learning at 8925887264 for the most current fee details. We offer flexible payment options and EMI plans to make the Gen AI course accessible for freshers and working professionals." },
                                { q: "What is the duration of the Gen AI course at PeopleClick Coimbatore?", a: "The standard batch runs for 12 weeks (3 months) covering 8 modules with 4–5 hours of training per week plus project labs. Fast-track options are available." },
                                { q: "Do I need prior AI or Data Science experience to join?", a: "No. Module 1 starts from Python basics and AI fundamentals. Anyone with a basic understanding of programming can join. If you're a complete beginner, we provide preparatory Python modules." },
                                { q: "Does PeopleClick provide 100% placement support for the Gen AI course?", a: "Yes — placement support is unlimited. Every student gets AI-specific resume building, unlimited mock interviews, and direct referrals to our 500+ hiring partners." },
                                { q: "Is the training available online or only at the Coimbatore center?", a: "Both modes are available. Offline classroom training happens at our RS Puram, Coimbatore center. Live online batches run via Zoom with full interactivity." },
                                { q: "What salary can I expect after completing the Gen AI training in Coimbatore?", a: "PeopleClick alumni have been placed as Prompt Engineers (₹6–10 LPA), LLM Application Developers (₹8–14 LPA), and Generative AI Engineers (₹10–22 LPA)." }
                            ].map((faq, i) => (
                                <div key={i} className="border rounded-xl bg-white overflow-hidden transition-all duration-300" style={{ borderColor: activeFaq === i ? themeColors.red : themeColors.border }}>
                                    <button
                                        onClick={() => setActiveFaq(activeFaq === i ? null : i)}
                                        className="w-full flex items-center justify-between p-5 text-left transition-colors"
                                    >
                                        <span className="font-bold text-base md:text-lg" style={{ color: themeColors.text }}>{faq.q}</span>
                                        <ChevronDown className={`w-5 h-5 transition-transform duration-300 ${activeFaq === i ? 'rotate-180' : ''}`} style={{ color: themeColors.red }} />
                                    </button>
                                    <div className={`transition-all duration-300 ease-in-out ${activeFaq === i ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`}>
                                        <div className="p-5 pt-0 border-t" style={{ borderColor: themeColors.border }}>
                                            <p className="text-sm md:text-base leading-relaxed" style={{ color: themeColors.textMuted }}>{faq.a}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>



            {/* ── FOOTER ── */}
            <footer className="border-t pt-16 pb-8 text-left" style={{ backgroundColor: themeColors.text, borderColor: '#2d2d2d' }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
                        <div>
                            <div className="text-2xl md:text-3xl font-black tracking-tight text-white mb-3">PEOPLECLICK <span style={{ color: themeColors.red }}>LEARNING</span></div>
                            <p className="text-sm sm:text-base leading-relaxed" style={{ color: '#9ca3af' }}>We are a leading online education platform offering 50+ courses to enhance your skills and abilities. With over 1,000+ success stories, we help learners get job-ready in Generative AI and Full Stack Development.</p>
                        </div>

                        <div>
                            <h4 className="text-white font-bold mb-4">Bangalore Office</h4>
                            <p className="text-sm" style={{ color: '#9ca3af' }}>#230, Level-3,<br />KAS Officers Colony, Stage 2,<br />Bengaluru, Karnataka 560068</p>

                            <h4 className="text-white font-bold mt-6 mb-3">Coimbatore Office</h4>
                            <p className="text-sm" style={{ color: '#9ca3af' }}>141A, Ratna RK Buildings 1st Floor,<br />Diwan Bahadur Road, RS Puram,<br />Coimbatore, Tamilnadu 641002</p>
                        </div>

                        <div>
                            <h4 className="text-white font-bold mb-4">Get in Touch</h4>
                            <ul className="space-y-3 text-sm" style={{ color: '#9ca3af' }}>
                                <li className="flex items-center gap-2"><Phone className="w-4 h-4" /> <a href="tel:+918925887264" className="transition-colors hover:text-white" style={{ color: themeColors.red }}>+91 8925 887 264 - Bangalore</a></li>
                                <li className="flex items-center gap-2"><Phone className="w-4 h-4" /> <a href="tel:+917338497706" className="transition-colors hover:text-white" style={{ color: themeColors.red }}>+91 733 849 7706 - Coimbatore</a></li>
                                <li className="flex items-center gap-2"><Mail className="w-4 h-4" /> <a href="mailto:training@peopleclick.in" className="transition-colors hover:text-white" style={{ color: themeColors.red }}>training@peopleclick.in</a></li>
                            </ul>
                        </div>
                    </div>

                    <div className="text-center border-t pt-8 text-xs" style={{ borderColor: '#2d2d2d', color: '#6b7280' }}>
                        © 2026 Peopleclick Learning. All rights reserved.
                    </div>
                </div>
            </footer>

            {/* ── MOBILE FLOAT CTA ── */}
            <div className={`fixed bottom-0 left-0 right-0 p-3 bg-white border-t flex gap-3 lg:hidden z-50 transition-transform duration-300 transform ${showFloatCta ? 'translate-y-0' : 'translate-y-full'}`}
                style={{ borderColor: themeColors.border, boxShadow: '0 -4px 20px rgba(0,0,0,0.08)' }}>
                <a href="https://wa.me/918925887264?text=Hi,%20I'm%20interested%20in%20the%20Generative%20AI%20course" target="_blank" rel="noopener noreferrer"
                    className="flex-1 text-white text-center font-bold text-xs sm:text-sm py-3 rounded-lg flex items-center justify-center gap-2 transition-transform hover:scale-105"
                    style={{ backgroundColor: '#25d366' }}>
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" /></svg>
                    WhatsApp Us
                </a>
                <a href="#lead-form" onClick={handleScrollToForm} className="flex-1 text-center text-white font-bold text-xs sm:text-sm py-3 rounded-lg"
                    style={{ background: themeColors.gradientRed }}>
                    Get Free Demo
                </a>
            </div>

            {/* ── WHATSAPP FLOATING BUTTON ── */}
            <div className="fixed bottom-20 right-4 z-50 lg:bottom-6 lg:right-6">
                <a
                    href="https://wa.me/918925887264?text=Hi,%20I'm%20interested%20in%20the%20Generative%20AI%20course"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group w-16 h-16 rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-all border-2 border-white"
                    style={{ backgroundColor: '#25d366', boxShadow: '0 10px 20px rgba(37,211,102,0.35)' }}
                >
                    <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" />
                    </svg>

                    {/* Tooltip */}
                    <div className="absolute right-20 bottom-2 w-48 bg-white text-slate-900 text-xs font-bold p-3 rounded-lg shadow-xl opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                        Chat with us on WhatsApp!
                        <div className="absolute right-0 bottom-3 translate-x-1/2 rotate-45 w-3 h-3 bg-white"></div>
                    </div>
                </a>
            </div>

            {/* ── VIDEO MODAL ── */}
            {selectedVideo && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6 backdrop-blur-sm bg-black/80" onClick={() => setSelectedVideo(null)}>
                    <div className="relative w-full max-w-5xl" onClick={(e) => e.stopPropagation()}>
                        <button
                            className="absolute -top-12 right-0 w-10 h-10 bg-white/20 hover:bg-red-500 text-white rounded-full flex items-center justify-center transition-colors z-10"
                            onClick={() => setSelectedVideo(null)}
                        >
                            <X className="w-5 h-5" />
                        </button>
                        <div className="w-full aspect-video bg-black rounded-2xl overflow-hidden shadow-2xl">
                            <iframe
                                className="w-full h-full"
                                src={`https://www.youtube.com/embed/${selectedVideo.id}?autoplay=1`}
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default GenAi;
